.circle {
  margin-right: 32px;
  height: 32px;
  width: 32px;
  background-color: var(--sfc-body-color-background);
  border-radius: 50%;
  border: 2px solid var(--sfc-color-brand-01);
  display: inline-block;
}

.password {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-tap-highlight-color: transparent; /* i.e. Nexus5/Chrome and Kindle Fire HD 7 */
  border: none !important;
  color: transparent;
  outline: none;
  position: absolute;
  background: none;
  font-size: 1px;
  text-indent: -9999px;
  margin: 0px !important;
  border: 0px !important;
  padding: 0px !important;
  left: 0;
  z-index: 10;
  opacity: 0;
  height: 32px;
  width: 100%;
}

#aria-summary {
  display: none;
}

#rass-tin-codes-container {
  margin-left: 32px;
}

.rass-tin-input-container {
  padding-top: 72px;
}

#rass-tin-code-input:focus + .rass-tin-code-active-0 .circle:nth-child(1),
#rass-tin-code-input:focus + .rass-tin-code-active-1 .circle:nth-child(2),
#rass-tin-code-input:focus + .rass-tin-code-active-2 .circle:nth-child(3),
#rass-tin-code-input:focus + .rass-tin-code-active-3 .circle:nth-child(4),
#rass-tin-code-input:focus + .rass-tin-code-active-4 .circle:nth-child(5) {
  box-shadow: var(
    --sfc-radio-button-label-box-shadow-active,
    0 0 0 3px rgba(255, 102, 0, 0.5),
    0 0 0 4px white inset
  );
}

.rass-tin-code-active-1 .circle:nth-child(1),
.rass-tin-code-active-2 .circle:nth-child(-n + 2),
.rass-tin-code-active-3 .circle:nth-child(-n + 3),
.rass-tin-code-active-4 .circle:nth-child(-n + 4),
.rass-tin-code-active-5 .circle:nth-child(-n + 5) {
  background-color: var(--sfc-color-brand-01) !important;
}
